import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
// import "react-datepicker/dist/react-datepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {ConfigProvider} from "antd";
import {HashRouter as BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import store from "./app/store/index";
import AppRoutes from "./app/routes/AppRoutes";

// Load the necessary plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Tashkent");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
    <Provider store={store}>
      <ConfigProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          {/* <App /> */}
          <AppRoutes/>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  // </React.StrictMode>
);
